import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '../../../app/api/apiSlice'

const userImprintCapabilitiesTechAreasAdapter = createEntityAdapter({})

const initialState = userImprintCapabilitiesTechAreasAdapter.getInitialState()

export const userImprintCapabilitiesTechAreasApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUserImprintCapabilitiesTechAreas: builder.query({
            query: () => ({
                url: '/userImprintCapabilitiesTechAreas/getUserImprintCapabilitiesTechAreas',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedUserImprintCapabilitiesTechAreas = responseData.map(userImprintCapabilitiesTechArea => {
                    userImprintCapabilitiesTechArea.id = userImprintCapabilitiesTechArea._id
                    return userImprintCapabilitiesTechArea
                })
                return userImprintCapabilitiesTechAreasAdapter.setAll(initialState, loadedUserImprintCapabilitiesTechAreas)
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        {type: 'UserImprintCapabilitiesTechArea', id: 'LIST'},
                        ...result.ids.map(id => ({ type: 'UserImprintCapabilitiesTechArea', id}))
                    ]
                } else {
                    return [ { type: 'UserImprintCapabilitiesTechArea', id: 'LIST'}]
                }
            },
        }),
        createNewUserImprintCapabilitiesTechArea: builder.mutation({
            query: initialUserImprintCapabilitiesTechArea => ({
                url: '/userImprintCapabilitiesTechAreas/createNewUserImprintCapabilitiesTechArea',
                method: 'POST',
                body: {...initialUserImprintCapabilitiesTechArea,}
            }),
            invalidatesTags: [
                { type: 'UserImprintCapabilitiesTechArea', id: "LIST" }
            ] 
        }),
        updateUserImprintCapabilitiesTechArea: builder.mutation({
            query: initialUserImprintCapabilitiesTechArea => ({
                url: '/userImprintCapabilitiesTechAreas/updateUserImprintCapabilitiesTechArea',
                method: 'PATCH',
                body: {...initialUserImprintCapabilitiesTechArea,}
            }),
            invalidatesTags: (result, error, arg) => [
                {type: 'UserImprintCapabilitiesTechArea', id: arg.id },
                { type: 'UserImprintCapabilitiesTechArea', id: 'LIST' }
            ],
        }),
        deleteUserImprintCapabilitiesTechArea: builder.mutation({
            query: ({id}) => ({
                url: '/userImprintCapabilitiesTechAreas/deleteUserImprintCapabilitiesTechArea',
                method: 'DELETE',
                body: {id}
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'UserImprintCapabilitiesTechArea', id: arg.id}
            ]
        }),
    }),
})

export const {
    useGetUserImprintCapabilitiesTechAreasQuery,
    useCreateNewUserImprintCapabilitiesTechAreaMutation,
    useUpdateUserImprintCapabilitiesTechAreaMutation,
    useDeleteUserImprintCapabilitiesTechAreaMutation,
} = userImprintCapabilitiesTechAreasApiSlice

// returns the query result object
export const selectUserImprintCapabilitiesTechAreaResult = userImprintCapabilitiesTechAreasApiSlice.endpoints.getUserImprintCapabilitiesTechAreas.select()

// create memoized selector
const selectUserImprintCapabilitiesTechAreasData = createSelector(
    selectUserImprintCapabilitiesTechAreaResult,
    userImprintCapabilitiesTechAreaResult => userImprintCapabilitiesTechAreaResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllUserImprintCapabilitiesTechAreas,
    selectById: selectUserImprintCapabilitiesTechAreaById,
    selectIds: selectUserImprintCapabilitiesTechAreaIds,
} = userImprintCapabilitiesTechAreasAdapter.getSelectors(state => selectUserImprintCapabilitiesTechAreasData(state) ?? initialState)